declare interface Number {
  mul: (_v: number) => number
}

function accMul(arg1: number, arg2: Number) {
  let m = 0
  const s1 = arg1.toString(),
    s2 = arg2.toString()
  try {
    if (s1.split('.')[1]) {
      m += s1.split('.')[1].length
    }
  } catch (e) {
    console.log(e)
  }
  try {
    if (s2.split('.')[1]) {
      m += s2.split('.')[1].length
    }
  } catch (e) {
    console.log(e)
  }
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  )
}

// 给Number类型增加一个mul方法，调用起来更加方便。
Number.prototype.mul = function (arg: number) {
  return accMul(arg, this)
}
